import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToHash } from '../../utils/scrolling';
import useBreakpoint from './useBreakpoint';

/**
 * Scrolls document to hash if any on url
 * @returns null
 */
function useScrollToHash(offset = 0, offsetMobile = 0) {

  const location = useLocation();
  const breakpoint = useBreakpoint();

  useLayoutEffect(() => {
    if (location.hash) {
      scrollToHash(location.hash, breakpoint === 'xs' ? offsetMobile : offset);
    }
  });

  return null;
}

export default useScrollToHash;